export default __webpack_public_path__ + "static/media/yummy-trans.213a4cbd.svg";